/* @flow */
// typecheck: ignore file
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import cx from 'classnames';
import React from 'react';

import type { LoadMembershipOptions } from 'reducers/peopleTables';
import { removeMembers, unselectAllMembership, loadMembership } from 'reducers/peopleTables';
import BatchRoleCorrectionModal from 'users/components/BatchRoleCorrectionModal.jsx';
import Button from 'components/Button.jsx';
import Glyph from 'components/Glyph.jsx';
import Group from 'entities/Group';
import GroupMembership from 'entities/GroupMembership';
import ModalTrigger from 'components/ModalTrigger.jsx';
import RemoveFromOrgModal from 'organizations/components/RemoveFromOrgModal.jsx';
import RequestTranscriptModal from 'organizations/components/RequestTranscriptModal.jsx';
import Text from 'components/Text.jsx';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import './styles/PeopleTableSuperActions.scss';

type Props = {
  group: Group,
  className?: string,

  /* redux props */
  selectedMemberships: Map<number, GroupMembership>,
  removeMembers: (groupId: number, userIds: number[]) => any,
  unselectAllMembership: (groupId: number) => any,
  loadMembership: (groupId: number, userId: number, options: LoadMembershipOptions) => any,
}

class PeopleTableSuperActions extends React.Component {
  props: Props;

  shouldRenderAction = (permission: string) => {
    return this.props.selectedMemberships.every((groupMembership) => groupMembership.hasPermission(permission));
  };

  renderRequestTranscriptModal = () => {
    const { selectedMemberships, group } = this.props;
    const organizations = group.getOrganization();

    const users = selectedMemberships.toArray().map(m => {
      return {
        id: m.getUserId(),
        fullName: m.getUser().getFullName(),
        firstName: m.getUser().getFirstName(),
        canGetMessageHistory: m.hasPermission('can_get_message_history'),
        canRequestMessageHistory: m.hasPermission('can_request_message_history'),
      };
    });

    return (
      <RequestTranscriptModal
        users={users}
        organizationId={organizations.id}
        organizationName={organizations.getName()}
      />
    );
  };

  unselectAllMembership = () => {
    this.props.unselectAllMembership(this.props.group.id);
  }

  onUserRoleSave = (userId: number) => {
    this.props.loadMembership(this.props.group.id, userId, { update: true });
  }

  removeAllSelected = () => {
    const ids = this.props.selectedMemberships.toArray().map(m => m.getUserId());
    this.props.removeMembers(this.props.group.id, ids);
  }

  renderRemoveFromOrgModal = () => {
    const { selectedMemberships, group } = this.props;
    const userIds = selectedMemberships.toArray().map(m => m.getUserId());
    const organizations = group.getOrganization();

    return (
      <RemoveFromOrgModal
        isAdminView
        group={group}
        userIds={userIds}
        orgId={organizations.id}
        onRemoved={this.removeAllSelected}
        orgName={organizations.getName()}
      />
    );
  };

  renderChangeRolesModal = () => {
    const { selectedMemberships, group } = this.props;
    return (
      <BatchRoleCorrectionModal
        group={group}
        groupMemberships={selectedMemberships.toArray()}
        onUserRoleSave={this.onUserRoleSave}
      />
    );
  };

  renderItem(glyph: any, text: string) {
    return (
      <Button
        size="xsmall"
        color="white"
        level="secondary"
        className="PeopleTableSuperActions-item"
        eventElementName="PeopleTableSuperActions-item">
        <Glyph name={glyph} size="large" />
        <Text size="xsmall">{text}</Text>
      </Button>
    );
  }

  renderActions() {
    const { selectedMemberships } = this.props;
    const selectedCount = selectedMemberships.size;

    if (selectedCount === 0) {
      return null;
    }

    const moreThanOneSelected = selectedCount > 1;

    return (
      <div key="actions" className={cx('PeopleTableSuperActions', this.props.className)}>
        <div>
          {this.shouldRenderAction('can_change_role') &&
            <ModalTrigger modal={this.renderChangeRolesModal()}>
              {this.renderItem('avatar', moreThanOneSelected ? 'Change roles' : 'Change role')}
            </ModalTrigger>}
          {this.shouldRenderAction('can_request_message_history') &&
            <ModalTrigger modal={this.renderRequestTranscriptModal()}>
              {this.renderItem('email-transcript', 'Get message history')}
            </ModalTrigger>}
          {this.shouldRenderAction('can_remove_from_org') &&
            <ModalTrigger modal={this.renderRemoveFromOrgModal()}>
              {this.renderItem('close', 'Remove from school')}
            </ModalTrigger>
          }
        </div>

        <div>
          <Text color="wolf" className="PeopleTableSuperActions-numberInfo">
            {moreThanOneSelected ?
              `${selectedCount} people selected` :
              `${selectedCount} person selected`
            }
          </Text>
          <Button
            size="xsmall"
            color="white"
            level="secondary"
            onClick={this.unselectAllMembership}>
            Deselect all
          </Button>
        </div>
      </div>
    );
  }

  render() {
    return (
      <ReactCSSTransitionGroup
        transitionName="PeopleTableSuperActions-transition"
        transitionEnterTimeout={300}
        transitionLeaveTimeout={300}>
        {this.renderActions()}
      </ReactCSSTransitionGroup>
    );
  }
}

function mapStateToProps(state: any, props: Props) {
  const table = state.peopleTables.get(props.group.id);

  return {
    selectedMemberships: table ? table.selectedMemberships : new Map(),
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ removeMembers, unselectAllMembership, loadMembership }, dispatch);
}

export { PeopleTableSuperActions };
export default connect(mapStateToProps, mapDispatchToProps)(PeopleTableSuperActions);



// WEBPACK FOOTER //
// ./src/components/PeopleTableSuperActions.jsx